module.exports = __webpack_public_path__ + "static/media/illustration.f70936ca.svg";